import { Family, Member } from "../patents/patents"
import { usePatents } from "../patents/PatentsProvider"
import { familyUrl, memberUrl } from "../patents/utils"
    
export function useRenderAsLink() {
    const { memberByReference, familyByReference } = usePatents()
    const renderAsLink = makeRenderAsLink({memberByReference, familyByReference})
    return {renderAsLink}
}
export const splitRegex = /([ \t\n\r\f\v;,.:?!()*])/;

export function makeRenderAsLink({memberByReference, familyByReference}: {memberByReference: Record<string, Member>, familyByReference: Record<string, Family>}) {

    function renderAsLink(token: string) {
      let url = undefined
      if (token in memberByReference) {
        url = memberUrl({internalReference: token})
      } else if (token in familyByReference) {
        url = familyUrl({internalReference: token})
      }

      if (url) {
        // console.log(url, token)
        return `[${token}](${url})`
      } else {
        // console.log(token)
        return token
      }
    }

    return renderAsLink
}